import { render, staticRenderFns } from "./RoApcnSelect2.vue?vue&type=template&id=127f2c80&"
import script from "./RoApcnSelect2.vue?vue&type=script&lang=js&"
export * from "./RoApcnSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports